import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-editpayrolldet',
  templateUrl: './editpayrolldet.component.html',
  styleUrls: ['./editpayrolldet.component.css']
})
export class EditpayrolldetComponent implements OnInit {


  constructor(private toastr: ToastrService,private appService: AppdataService,
    private loginService: LoginserviceService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
       
    }

  //Save Validation
  submitted:boolean;
  successfully:boolean;


  //Edit Get Values
  payrollColl:any=[];

  @Input() payrollid:any=0;
  @Input() empid: any = null
  @Input() empname:any=null

  @Output() emitData = new EventEmitter();

  private gridApi;
  private gridColumnApi;
  pinnedBottomRowData;

columnDefs = [        
    { headerName: 'Section', field: 'sectionname' }, 
    { headerName: 'Earning', field: 'earningamount'},
    { headerName: 'Deducting', field: 'deductionamount' }, 
    { headerName: 'Total', field: 'totalamount' }, 
  ]

  gridOptions = {       
    rowSelection:'single',
    rowHeight:40,   
    columnDefs: this.columnDefs,
    defaultColDef: {
      resizable: true,floatingFilter: true,
      flex: 1,
      width:100,
      minWidth: 100,      
     sortable: true,
      filter: true,       
    },         
  };


  ngOnInit() {

  }

   //Grid
   fnGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;   
  }

  
  //Get 
  fngetPayrolldetails() {
    var data = {
    'empid':this.empid,
    'payrollid':this.payrollid         
    }

    console.log(data)
    this.appService.fngetPayRollByEmpid(data)
    .subscribe(
    (res)=>{                
        if (res.json().status === 200) {  
         
          this.payrollColl = res.json().result[0]; 
          
           
          this.pinnedBottomRowData = res.json().result[1];
        }
        else {
          this.loginService.fnAPIError(res.json())
        }

    },
    (err)=>{          
    this.toastr.error('Error', err);
    })
  }

fnSaveBtnClick(){
try{
  this.emitData.emit("DONE");  
  this.activeModal.close(true); 

}catch(ex){
this.fnShowErrorMsg(ex);
}
}



public decline() {
this.activeModal.close(false);
}


private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}




}
